import { Directive } from '@angular/core';
import { Validators, ValidatorFn, Validator, AbstractControl } from '@angular/forms';

@Directive({
  selector: '[appCustomValidators]'
})
export class CustomValidatorsDirective {

 
  constructor() {    
   }

  }

  export function min(value: number){
    return (control: AbstractControl): {[key: string]: any} => {
      if (control.value !== null && control.value<value) {
        return {'min': {'value': control.value}};
     } else {
       return null;
     }
    }
  }
  export function max(value: number){
    return (control: AbstractControl): {[key: string]: any} => {
      if (control.value !== null && control.value>value) {
        return {'max': {'value': control.value}};
     } else {
       return null;
     }
    }
  }
  export function integer(){
    return (control: AbstractControl): {[key: string]: any} => {
      if (control.value !== null && Number.isInteger(control.value) === false) {
        return {'integer': {'value': control.value}};
     } else {
       return null;
     }
    }
  }
  





// WEBPACK FOOTER //
// ./src/app/shared/validators/custom-validators.directive.ts